import styled from "@emotion/styled";
import { StylesConfig } from "react-select";
import theme from "../../../../../UI/theme";

export const InputsMainWrapper = styled.div`
    display: flex;
    gap: 0.75rem;
    @media screen and (max-width: 1220px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`;

export const roomCustomStyles: StylesConfig = {
    valueContainer: (provided) => ({
        ...provided,
        flexWrap: "nowrap",
        padding: 0,
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: "0 0 0 0.5rem",
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    control: (provided) => ({
        ...provided,
        padding: "1px 6px",
        width: "200px",
        cursor: "pointer",
        "@media screen and (max-width: 1220px)": {
            width: "270px",
        },
    }),
    placeholder: (provided) => ({
        ...provided,
        whiteSpace: "nowrap",
    }),
};

export const examinationCustomStyles: StylesConfig = {
    valueContainer: (provided) => ({
        ...provided,
        flexWrap: "nowrap",
        padding: 0,
        overflowX: "auto",
    }),
    dropdownIndicator: () => ({
        display: "none",
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    multiValue: (provided) => ({
        ...provided,
        minWidth: "100px",
        fontSize: "18px",
        padding: "1px 0",
    }),
    menuList: (provided) => ({
        ...provided,
        display: "flex",
        flexDirection: "column",
        width: "500px",
        maxHeight: "230px",
    }),
    menu: (provided) => ({
        ...provided,
        minHeight: "230px",
        width: "unset",
    }),
    control: (provided) => ({
        ...provided,
        padding: "2px 6px",
        width: "220px",
        backgroundColor: "#f8f9fa",
        borderColor: "#f8f9fa",
        border: "none",
        cursor: "pointer",
        position: "relative",
        "&:hover": {
            backgroundColor: " #e2e6ea",
            borderColor: "#dae0e5",
        },
        "@media screen and (max-width: 1220px)": {
            width: "270px",
        },
    }),
    option: (provided, state) => ({
        ...provided,
        display: "flex",
        justifyContent: "space-between",
    })
};

export const TimeInput = styled.input`
    border-radius: 10px;
    border: 1px solid ${theme.colors.lightGray};
    padding: 1px 6px;
    background-color: white;
    width: 120px;
    height: 38px;
`;

export const TimeContainer = styled.div`
    display: flex;
    gap: 0.75rem;
    align-items: center;
`;

export const InputContainer = styled.div`
    display: flex;
    gap: 0.75rem;
    align-items: center;
`;
